import React from "react";
import Layout from "../../layout/adminExt/Layout";
import Referral from "./Referral";

export default function Index() {
  return (
    <Layout>
      <Referral />
    </Layout>
  );
}
